export const getQuizReportTableHeaders = () =>
	Object.freeze(['Event', 'Amount', 'Partial CR', 'Total CR']);
